import clsx from 'clsx'
import _ from 'lodash'
import BootstrapTable, {ColumnDescription} from 'react-bootstrap-table-next'
import {FolderDTO} from '../../api/data-contracts'
import {setSelectedFolder, loadDocuments, getDocumentState} from '../../redux/documentSlice'
import {useDispatch, useSelector} from 'react-redux'
import FolderBadges from './FolderBadges'

function FoldersSubTable(props: {folders: FolderDTO[]}) {
  const dispatch = useDispatch()

  const documentState = useSelector(getDocumentState)

  const subRowClasses = (row: FolderDTO, rowIndex: number): string => {
    return clsx('border-bottom ', {
      'table-active': row.id === documentState.selectedFolder?.id,
    })
  }

  const subColumns: ColumnDescription[] = [
    {
      dataField: 'id',
      text: 'Klasörler',
      sort: false,
      classes: 'fs-8 ps-10 px-0',
      headerStyle: {display: 'none'},
      formatter: (cell: any, row: FolderDTO, rowIndex: number, colIndex: number) => (
        <div className='d-flex justify-content-between pe-4'>
          <div>
            <i className='bi bi-folder fs-4 text-gray-900 me-3'></i>
            {row.name}
          </div>
          <FolderBadges folder={row} />
        </div>
      ),
    },
  ]

  return (
    <BootstrapTable
      keyField='id'
      data={_.orderBy(props.folders, ['activationTime', 'name'], ['desc', 'asc']) ?? []}
      columns={subColumns}
      classes='table border-top gs-7 mb-0'
      rowClasses={subRowClasses}
      headerClasses='fw-bold fs-6 text-gray-800 bg-primary bg-opacity-50'
      rowStyle={{cursor: 'pointer'}}
      rowEvents={{
        onClick: async (e, row: FolderDTO, rowIndex) => {
          await dispatch(setSelectedFolder(row))
          await dispatch<any>(loadDocuments())
        },
      }}
    />
  )
}

export default FoldersSubTable
